import React from "react";
import { I18n } from "@aws-amplify/core";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { get, size } from "lodash";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";

import DataPrivacyDocument from "./DataPrivacyDocument";
import DataPrivacyPoliciesTable from "./DataPrivacyPoliciesTable";
import { ok, denied, warning } from "../../../constants/common";
import images from "../../../assets/img/images";
import colors from "../../../assets/style/colors";
import FoldableSection from "../../Common/FoldableSection";

const styles = (theme) => ({
  card: {
    padding: "24px",
    backgroundColor: colors.white,
    overflow: "auto",
    borderRadius: "2px",
    [theme.breakpoints.up("sm")]: {
      maxHeight: "calc(100vh - 247px)",
      height: "calc(100vh - 247px)",
      margin: "12px",
      boxShadow: `0px 2px 2px 0px ${colors.black23}`,
    },
    [theme.breakpoints.down("sm")]: {
      margin: "12px 6px",
      maxHeight: "calc(100vh - 212px)",
      height: "calc(100vh - 212px)",
    },
  },
  documentContainer: {
    border: `1px solid ${colors.darkGrey}`,
    borderRadius: "4px",
    maxWidth: "1000px",
    marginTop: "55px",
    marginLeft: "100px",
  },
});

const ProfileDataPrivacy = (props) => {
  const { classes, language, policies, isMe, permissions } = props;
  const [selectedPolicy, setSelectedPolicy] = React.useState();
  const [policyContent, setPolicyContent] = React.useState();

  return (
    <Box className={classes.card}>
      <Grid container style={{ maxWidth: "1400px" }}>
        <Grid item xs={6} style={{ maxWidth: "600px" }}>
          <Grid container direction="column">
            <Grid item style={{ marginBottom: "24px" }}>
              <Grid container alignItems="center">
                <Grid item>
                  <img
                    src={
                      get(policies, ["status", "status"]) === ok
                        ? images.dataPrivacyIconGreen
                        : get(policies, ["status", "status"]) === denied
                          ? images.dataPrivacyIconRed
                          : get(policies, ["status", "status"]) === warning
                            ? images.dataPrivacyIconOrange
                            : images.dataPrivacyIconBlack
                    }
                    alt="data_privacy"
                  />
                </Grid>
                <Grid
                  item
                  className="text-87 bold-500"
                  style={{ textTransform: "uppercase", marginLeft: "10px" }}
                >
                  {I18n.get("profiles_privateUserData")}
                </Grid>
                <Grid
                  item
                  className="text-italic text-54"
                  style={{ fontSize: "0.857em", marginLeft: "10px" }}
                >
                  {get(policies, ["status", "status"]) &&
                    `(
                    ${I18n.get(
                      get(policies, ["status", "status"]) === ok
                        ? "profiles_accepted"
                        : get(policies, ["status", "status"]) === denied
                          ? "profiles_refused"
                          : get(policies, ["status", "status"]) === warning
                            ? "profiles_pendingConsent"
                            : ""
                    )}
                  )`}
                </Grid>
              </Grid>
            </Grid>
            <Grid item>{I18n.get("profiles_dataPrivacyText")}</Grid>
            <Grid item style={{ marginTop: "24px" }}>
              <DataPrivacyPoliciesTable
                policies={get(policies, ["policies"])}
                acceptances={get(policies, ["acceptances"])}
                setPolicyContent={setPolicyContent}
                selectedPolicy={selectedPolicy}
                setSelectedPolicy={setSelectedPolicy}
                language={language}
              />
            </Grid>
            <Grid item style={{ marginTop: "70px" }}>
              <FoldableSection
                title={`${I18n.get("profiles_archivedPolicies")} (${size(
                  get(policies, ["archivedPolicies"])
                )})`}
                defaultOpen={false}
              >
                <DataPrivacyPoliciesTable
                  policies={get(policies, ["archivedPolicies"])}
                  acceptances={get(policies, ["acceptances"])}
                  setPolicyContent={setPolicyContent}
                  selectedPolicy={selectedPolicy}
                  setSelectedPolicy={setSelectedPolicy}
                  language={language}
                />
              </FoldableSection>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs className={classes.documentContainer}>
          <DataPrivacyDocument
            selectedPolicy={selectedPolicy}
            policyContent={policyContent}
            policies={policies}
            permissions={permissions}
            isMe={isMe}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    language: state.user.language,
    policies: state.policies,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(ProfileDataPrivacy));
